import { VerifiedCell } from '@components/DataGrid';
import { GridRenderCellParams } from '@mui/x-data-grid';
import React from 'react';

const UserPhoneCell: React.FC<GridRenderCellParams<string>> = ({
	value,
	row
}) => (
	<VerifiedCell
		value={value || ''}
		isVerified={row.verifiedPhone}
		verifiedTitle={intl.tr('users.phoneNumber.verified')}
		unverifiedTitle={intl.tr('users.phoneNumber.unverified')}
	/>
);

export default UserPhoneCell;
